import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Subscription } from "../Types/SubscriptionInterface";

interface SubscriptionState {
    subscriptions: Subscription[];
    loading: boolean;
    error: string | null;
    userTypeSubscriptions: Subscription[];
}

const initialState: SubscriptionState = {
    subscriptions: [],
    loading: false,
    error: null,
    userTypeSubscriptions : [],
}

const subscriptionSlice = createSlice({
    name: 'subscriptions',
    initialState,
    reducers: {
        fetchPlansStart: (state) => {
            state.loading = true;
            state.error = null;
          },
          fetchPlansSuccess: (state, action: PayloadAction<Subscription[]>) => {
            state.subscriptions = action.payload;
            state.loading = false;
            state.userTypeSubscriptions = [];
          },
          fetchPlansFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
          },
          filterPlansBySelectedUserTpe: (state, action: PayloadAction<number>) => {
            const plansByUserType = state.subscriptions.filter(sub => sub.user_type_id === action.payload);
            state.userTypeSubscriptions = plansByUserType;
          },
          incrementNumberOfProjects: (state, action: PayloadAction<number>) => {
            const plan = state.userTypeSubscriptions.find(sub => sub.id === action.payload);
            if(plan){
              if(plan.numberOfProjects <= plan.max_license_counts){
                plan.numberOfProjects +=1;
              }
              
            }
          },
          decrementNumberOfProjects: (state, action: PayloadAction<number>) => {
            const plan = state.userTypeSubscriptions.find(sub => sub.id === action.payload);
            if(plan && plan.numberOfProjects > 0){
              plan.numberOfProjects -=1;
            }
          }
        }
})

export const { fetchPlansStart, fetchPlansSuccess, fetchPlansFailure, incrementNumberOfProjects, decrementNumberOfProjects, filterPlansBySelectedUserTpe } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;